import React, { useState, useEffect } from 'react';
import {



  SafeAreaView,
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Dimensions,
  ScrollView,
  RefreshControl,
  StatusBar,
  Alert,
  Modal,
  FlatList,
  ActivityIndicator,
  TextInput,
} from 'react-native';
import {
  MaterialCommunityIcons,
} from '@expo/vector-icons';
import { LinearGradient } from 'expo-linear-gradient';
import AsyncStorage from '@react-native-async-storage/async-storage';

// ===== API Configuration =====
const API_BASE_URL = 'https://api.jobeng.ai';

const getCompanyId = async () => {
  try {
    const userData = await AsyncStorage.getItem('currentUser');
    if (userData) {
      const user = JSON.parse(userData);
      return user.company_id || user.companyId || null;
    }
    const companyProfile = await AsyncStorage.getItem('companyProfile');
    if (companyProfile) {
      const company = JSON.parse(companyProfile);
      return company.id || company.company_id || null;
    }
    return null;
  } catch (e) {
    console.error('Error getting company_id:', e);
    return null;
  }
};

const apiRequest = async (endpoint, options = {}) => {
  try {
    const companyId = await getCompanyId();
    // Split endpoint and query string
    const [path, queryString] = endpoint.split('?');
    // Route: auth/* goes to /api/auth/*, everything else to /api/data/{table}
    let baseUrl;
    if (path.startsWith('auth/')) {
      baseUrl = `${API_BASE_URL}/api/${path}`;
    } else {
      // Convert hyphens to underscores for DB table mapping
      const dbPath = path.replace(/-/g, '_');
      baseUrl = `${API_BASE_URL}/api/data/${dbPath}`;
    }
    const params = new URLSearchParams(queryString || '');
    if (companyId) params.set('company_id', companyId);
    const separator = params.toString() ? '?' : '';
    const url = `${baseUrl}${separator}${params.toString()}`;

    const response = await fetch(url, {
      headers: { 'Content-Type': 'application/json' },
      ...options,
      ...(options.body ? { body: JSON.stringify(options.body) } : {}),
    });

    if (!response.ok) throw new Error(`API error: ${response.status}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`API request failed for ${endpoint}:`, error);
    throw error;
  }
};
// ===== End API Configuration =====


const { width, height } = Dimensions.get('window');

export default function SupportTicketsScreen({ navigation }) {
  const [isLoading, setIsLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [activeTab, setActiveTab] = useState('tickets');
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterPriority, setFilterPriority] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  // Ticket statuses and priorities
  const ticketStatuses = [
    { key: 'all', title: 'All Status', count: 15 },
    { key: 'open', title: 'Open', count: 6 },
    { key: 'in-progress', title: 'In Progress', count: 4 },
    { key: 'pending', title: 'Pending', count: 2 },
    { key: 'resolved', title: 'Resolved', count: 2 },
    { key: 'closed', title: 'Closed', count: 1 }
  ];

  const ticketPriorities = [
    { key: 'all', title: 'All Priority' },
    { key: 'critical', title: 'Critical' },
    { key: 'high', title: 'High' },
    { key: 'medium', title: 'Medium' },
    { key: 'low', title: 'Low' }
  ];

  // Support tickets data
  const [tickets, setTickets] = useState([
    {
      id: 'TKT-001',
      title: 'Delivery Delay - Construction Materials',
      description: 'Customer reports that the construction materials ordered last week have not arrived as scheduled. This is causing delays in their project timeline.',
      customer: 'Green Builders Ltd',
      contact: 'Sarah Wilson',
      email: 'sarah.wilson@greenbuilders.co.uk',
      phone: '+44 161 234 5678',
      category: 'delivery',
      priority: 'high',
      status: 'open',
      assignedTo: 'Mike Chen',
      createdAt: '2024-01-18T09:30:00Z',
      updatedAt: '2024-01-18T14:20:00Z',
      dueDate: '2024-01-19T17:00:00Z',
      resolutionTime: null,
      customerSatisfaction: null,
      tags: ['delivery', 'delay', 'construction'],
      attachments: ['delivery_schedule.pdf', 'order_confirmation.pdf'],
      comments: [
        {
          id: '1',
          author: 'Sarah Wilson',
          type: 'customer',
          content: 'We were expecting delivery yesterday but nothing arrived. Our project is now behind schedule.',
          timestamp: '2024-01-18T09:30:00Z'
        },
        {
          id: '2',
          author: 'Mike Chen',
          type: 'agent',
          content: 'I apologize for the delay. Checking with our logistics team now. Will update within 2 hours.',
          timestamp: '2024-01-18T10:15:00Z'
        },
        {
          id: '3',
          author: 'Mike Chen',
          type: 'agent',
          content: 'Update: Delivery truck had mechanical issues. New delivery scheduled for tomorrow morning 9 AM.',
          timestamp: '2024-01-18T14:20:00Z'
        }
      ],
      relatedTickets: [],
      escalationLevel: 0,
      slaStatus: 'at-risk'
    },
    {
      id: 'TKT-002',
      title: 'Product Quality Issue - Safety Equipment',
      description: 'Customer received safety helmets that do not meet the specified quality standards. Some helmets have visible defects and cracks.',
      customer: 'BuildFast Construction',
      contact: 'Robert Taylor',
      email: 'robert.taylor@buildfast.co.uk',
      phone: '+44 131 567 8901',
      category: 'quality',
      priority: 'critical',
      status: 'in-progress',
      assignedTo: 'David Brown',
      createdAt: '2024-01-17T14:45:00Z',
      updatedAt: '2024-01-18T11:30:00Z',
      dueDate: '2024-01-18T14:45:00Z',
      resolutionTime: null,
      customerSatisfaction: null,
      tags: ['quality', 'safety', 'defective'],
      attachments: ['defect_photos.zip', 'quality_report.pdf'],
      comments: [
        {
          id: '1',
          author: 'Robert Taylor',
          type: 'customer',
          content: 'Received 50 safety helmets but 8 of them have visible cracks. This is a safety concern for our workers.',
          timestamp: '2024-01-17T14:45:00Z'
        },
        {
          id: '2',
          author: 'David Brown',
          type: 'agent',
          content: 'This is serious. Arranging immediate replacement and quality inspection. Please do not use the defective helmets.',
          timestamp: '2024-01-17T15:30:00Z'
        },
        {
          id: '3',
          author: 'David Brown',
          type: 'agent',
          content: 'Replacement helmets dispatched via express delivery. Will arrive tomorrow. Also investigating with supplier.',
          timestamp: '2024-01-18T11:30:00Z'
        }
      ],
      relatedTickets: ['TKT-008'],
      escalationLevel: 1,
      slaStatus: 'breached'
    },
    {
      id: 'TKT-003',
      title: 'Invoice Discrepancy - Billing Error',
      description: 'Customer disputes the amount on invoice #INV-2024-003. Claims they were charged for items not received.',
      customer: 'TechCorp Ltd',
      contact: 'Mary Johnson',
      email: 'mary.johnson@techcorp.com',
      phone: '+44 20 7123 4568',
      category: 'billing',
      priority: 'medium',
      status: 'pending',
      assignedTo: 'Emma Wilson',
      createdAt: '2024-01-16T11:20:00Z',
      updatedAt: '2024-01-17T16:45:00Z',
      dueDate: '2024-01-20T11:20:00Z',
      resolutionTime: null,
      customerSatisfaction: null,
      tags: ['billing', 'invoice', 'dispute'],
      attachments: ['invoice_INV-2024-003.pdf', 'delivery_receipt.pdf'],
      comments: [
        {
          id: '1',
          author: 'Mary Johnson',
          type: 'customer',
          content: 'Invoice shows 100 units but we only received 85 units. Please adjust the billing.',
          timestamp: '2024-01-16T11:20:00Z'
        },
        {
          id: '2',
          author: 'Emma Wilson',
          type: 'agent',
          content: 'Reviewing the delivery records and invoice details. Will get back to you by end of day.',
          timestamp: '2024-01-16T13:45:00Z'
        },
        {
          id: '3',
          author: 'Emma Wilson',
          type: 'agent',
          content: 'Confirmed discrepancy. Preparing revised invoice. Waiting for finance approval.',
          timestamp: '2024-01-17T16:45:00Z'
        }
      ],
      relatedTickets: [],
      escalationLevel: 0,
      slaStatus: 'on-track'
    },
    {
      id: 'TKT-004',
      title: 'Technical Support - Software Installation',
      description: 'Customer needs assistance with installing and configuring the project management software they purchased.',
      customer: 'Urban Development Co',
      contact: 'Mike Chen',
      email: 'mike.chen@urbandev.com',
      phone: '+44 113 345 6789',
      category: 'technical',
      priority: 'medium',
      status: 'in-progress',
      assignedTo: 'Sarah Johnson',
      createdAt: '2024-01-15T10:15:00Z',
      updatedAt: '2024-01-18T09:20:00Z',
      dueDate: '2024-01-19T10:15:00Z',
      resolutionTime: null,
      customerSatisfaction: null,
      tags: ['technical', 'software', 'installation'],
      attachments: ['installation_guide.pdf', 'system_requirements.pdf'],
      comments: [
        {
          id: '1',
          author: 'Mike Chen',
          type: 'customer',
          content: 'Having trouble installing the software on our network. Getting compatibility errors.',
          timestamp: '2024-01-15T10:15:00Z'
        },
        {
          id: '2',
          author: 'Sarah Johnson',
          type: 'agent',
          content: 'Can you share your system specifications? I\'ll schedule a remote session to help with installation.',
          timestamp: '2024-01-15T14:30:00Z'
        },
        {
          id: '3',
          author: 'Sarah Johnson',
          type: 'agent',
          content: 'Remote session completed. Software installed successfully. Providing training materials.',
          timestamp: '2024-01-18T09:20:00Z'
        }
      ],
      relatedTickets: [],
      escalationLevel: 0,
      slaStatus: 'on-track'
    },
    {
      id: 'TKT-005',
      title: 'Return Request - Incorrect Product',
      description: 'Customer received wrong product model and wants to return it for the correct one.',
      customer: 'Construct Plus',
      contact: 'Emma Davis',
      email: 'emma.davis@constructplus.com',
      phone: '+44 121 456 7890',
      category: 'returns',
      priority: 'low',
      status: 'resolved',
      assignedTo: 'Mike Chen',
      createdAt: '2024-01-14T13:25:00Z',
      updatedAt: '2024-01-17T15:10:00Z',
      dueDate: '2024-01-18T13:25:00Z',
      resolutionTime: 72.75,
      customerSatisfaction: 4,
      tags: ['returns', 'wrong-product', 'exchange'],
      attachments: ['return_authorization.pdf'],
      comments: [
        {
          id: '1',
          author: 'Emma Davis',
          type: 'customer',
          content: 'Ordered Model A but received Model B. Need to exchange for the correct model.',
          timestamp: '2024-01-14T13:25:00Z'
        },
        {
          id: '2',
          author: 'Mike Chen',
          type: 'agent',
          content: 'Return authorized. Please use the prepaid shipping label. Correct model will be sent once we receive the return.',
          timestamp: '2024-01-14T16:20:00Z'
        },
        {
          id: '3',
          author: 'Mike Chen',
          type: 'agent',
          content: 'Return received and correct model shipped. Tracking number: TRK123456789',
          timestamp: '2024-01-17T15:10:00Z'
        }
      ],
      relatedTickets: [],
      escalationLevel: 0,
      slaStatus: 'met'
    }
  ]);

  // Support analytics
  const [analytics, setAnalytics] = useState({
    totalTickets: 15,
    openTickets: 6,
    avgResolutionTime: 48.5,
    customerSatisfaction: 4.2,
    slaCompliance: 87.5,
    firstResponseTime: 2.3,
    escalationRate: 12.5,
    topCategory: 'Technical',
    criticalTickets: 2,
    overdueTickets: 1
  });

  // Agent performance
  const [agentPerformance, setAgentPerformance] = useState([
    {
      id: '1',
      name: 'Sarah Johnson',
      role: 'Senior Support Agent',
      assignedTickets: 4,
      resolvedTickets: 8,
      avgResolutionTime: 36.2,
      customerSatisfaction: 4.6,
      firstResponseTime: 1.8,
      slaCompliance: 95,
      escalationRate: 5,
      efficiency: 'excellent'
    },
    {
      id: '2',
      name: 'Mike Chen',
      role: 'Support Agent',
      assignedTickets: 3,
      resolvedTickets: 5,
      avgResolutionTime: 52.1,
      customerSatisfaction: 4.1,
      firstResponseTime: 2.5,
      slaCompliance: 85,
      escalationRate: 15,
      efficiency: 'good'
    },
    {
      id: '3',
      name: 'David Brown',
      role: 'Technical Support Specialist',
      assignedTickets: 2,
      resolvedTickets: 3,
      avgResolutionTime: 41.8,
      customerSatisfaction: 4.4,
      firstResponseTime: 2.1,
      slaCompliance: 90,
      escalationRate: 10,
      efficiency: 'excellent'
    },
    {
      id: '4',
      name: 'Emma Wilson',
      role: 'Junior Support Agent',
      assignedTickets: 2,
      resolvedTickets: 2,
      avgResolutionTime: 68.3,
      customerSatisfaction: 3.8,
      firstResponseTime: 3.2,
      slaCompliance: 75,
      escalationRate: 25,
      efficiency: 'needs-improvement'
    }
  ]);


  // Load tickets from API
  const loadTicketsFromApi = async () => {
    try {
      const response = await apiRequest('support-tickets');
      if (response.success && response.data) {
        setTickets(response.data.tickets || response.data);
        if (response.data.analytics) setAnalytics(response.data.analytics);
        if (response.data.agentPerformance) setAgentPerformance(response.data.agentPerformance);
      }
    } catch (error) {
      console.warn('API unavailable, using local data:', error.message);
    } finally {
      loadTicketsFromApi();
    }
  };

  useEffect(() => {
    initializeScreen();
  }, []);

  const initializeScreen = async () => {
    try {
      setIsLoading(true);
      // Simulate loading data
      await new Promise(resolve => setTimeout(resolve, 1000));
    } catch (error) {
      console.error('Error initializing screen:', error);
      Alert.alert('Error', 'Failed to load support tickets');
    } finally {
      setIsLoading(false);
    }
  };

  const onRefresh = async () => {
    setRefreshing(true);
    await new Promise(resolve => setTimeout(resolve, 1000));
    setRefreshing(false);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatDuration = (hours) => {
    if (!hours) return 'N/A';
    if (hours < 24) return `${hours.toFixed(1)}h`;
    const days = Math.floor(hours / 24);
    const remainingHours = hours % 24;
    return `${days}d ${remainingHours.toFixed(1)}h`;
  };

  const getStatusColor = (status) => {
    const colors = {
      'open': '#EF4444',
      'in-progress': '#3B82F6',
      'pending': '#F59E0B',
      'resolved': '#10B981',
      'closed': '#6B7280'
    };
    return colors[status] || '#6B7280';
  };

  const getPriorityColor = (priority) => {
    const colors = {
      'critical': '#DC2626',
      'high': '#EF4444',
      'medium': '#F59E0B',
      'low': '#6B7280'
    };
    return colors[priority] || '#6B7280';
  };

  const getCategoryIcon = (category) => {
    const icons = {
      'delivery': 'truck',
      'quality': 'shield-alert',
      'billing': 'receipt',
      'technical': 'tools',
      'returns': 'keyboard-return',
      'general': 'help-circle'
    };
    return icons[category] || 'help-circle';
  };

  const getSlaStatusColor = (slaStatus) => {
    const colors = {
      'met': '#10B981',
      'on-track': '#3B82F6',
      'at-risk': '#F59E0B',
      'breached': '#EF4444'
    };
    return colors[slaStatus] || '#6B7280';
  };

  const getEfficiencyColor = (efficiency) => {
    const colors = {
      'excellent': '#10B981',
      'good': '#3B82F6',
      'needs-improvement': '#EF4444'
    };
    return colors[efficiency] || '#6B7280';
  };

  const getFilteredTickets = () => {
    let filtered = tickets;
    
    // Filter by status
    if (filterStatus !== 'all') {
      filtered = filtered.filter(ticket => ticket.status === filterStatus);
    }
    
    // Filter by priority
    if (filterPriority !== 'all') {
      filtered = filtered.filter(ticket => ticket.priority === filterPriority);
    }
    
    // Filter by search query
    if (searchQuery) {
      filtered = filtered.filter(ticket => 
        String(ticket.title ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
        String(ticket.customer ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
        String(ticket.contact ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
        String(ticket.id ?? '').toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
    
    return filtered.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
  };

  const updateTicketStatus = (ticketId, newStatus) => {
    const updatedTickets = tickets.map(ticket => 
      ticket.id === ticketId 
        ? { 
            ...ticket, 
            status: newStatus, 
            updatedAt: new Date().toISOString(),
            resolutionTime: newStatus === 'resolved' || newStatus === 'closed' 
              ? ((new Date() - new Date(ticket.createdAt)) / (1000 * 60 * 60)) 
              : ticket.resolutionTime
          }
        : ticket
    );
    setTickets(updatedTickets);
    Alert.alert('Success', `Ticket ${ticketId} status updated to ${newStatus}`);
  };

  const renderHeader = () => (
    <LinearGradient
      colors={['#1F2937', '#374151']}
      style={styles.header}
    >
      <View style={styles.headerContent}>
        <TouchableOpacity 
          onPress={() => navigation?.goBack()}
          style={styles.backButton}
        >
          <MaterialCommunityIcons name="arrow-left" size={24} color="#FFFFFF" />
        </TouchableOpacity>
        
        <View style={styles.headerCenter}>
          <Text style={styles.headerTitle}>Support Tickets</Text>
          <Text style={styles.headerSubtitle}>Customer Support Management</Text>
        </View>
        
        <TouchableOpacity 
          style={styles.headerButton}
          onPress={() => {
            setSelectedTicket(null);
            setShowTicketModal(true);
          }}
        >
          <MaterialCommunityIcons name="plus" size={24} color="#FFFFFF" />
        </TouchableOpacity>
      </View>
    </LinearGradient>
  );

  const renderTabs = () => (
    <View style={styles.tabsContainer}>
      <ScrollView 
        horizontal 
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={styles.tabsContent}
      >
        {[
          { key: 'tickets', title: 'Tickets', icon: 'ticket' },
          { key: 'analytics', title: 'Analytics', icon: 'chart-line' },
          { key: 'agents', title: 'Agent Performance', icon: 'account-group' },
          { key: 'sla', title: 'SLA Tracking', icon: 'clock-alert' }
        ].map((tab) => (
          <TouchableOpacity
            key={tab.key}
            style={[
              styles.tab,
              activeTab === tab.key && styles.activeTab
            ]}
            onPress={() => setActiveTab(tab.key)}
          >
            <MaterialCommunityIcons 
              name={tab.icon} 
              size={20} 
              color={activeTab === tab.key ? '#3B82F6' : '#6B7280'} 
            />
            <Text style={[
              styles.tabText,
              activeTab === tab.key && styles.activeTabText
            ]}>
              {tab.title}
            </Text>
          </TouchableOpacity>
        ))}
      </ScrollView>
    </View>
  );

  const renderStats = () => (
    <View style={styles.statsContainer}>
      <View style={styles.statCard}>
        <Text style={styles.statValue}>{analytics.totalTickets}</Text>
        <Text style={styles.statLabel}>Total</Text>
      </View>
      <View style={styles.statCard}>
        <Text style={styles.statValue}>{analytics.openTickets}</Text>
        <Text style={styles.statLabel}>Open</Text>
      </View>
      <View style={styles.statCard}>
        <Text style={styles.statValue}>{analytics.avgResolutionTime}h</Text>
        <Text style={styles.statLabel}>Avg Resolution</Text>
      </View>
      <View style={styles.statCard}>
        <Text style={styles.statValue}>{analytics.customerSatisfaction}</Text>
        <Text style={styles.statLabel}>Satisfaction</Text>
      </View>
    </View>
  );

  const renderSearchAndFilter = () => (
    <View style={styles.searchContainer}>
      <View style={styles.searchBox}>
        <MaterialCommunityIcons name="magnify" size={20} color="#6B7280" />
        <TextInput
          style={styles.searchInput}
          placeholder="Search tickets..."
          value={searchQuery}
          onChangeText={setSearchQuery}
          placeholderTextColor="#9CA3AF"
        />
        {searchQuery ? (
          <TouchableOpacity onPress={() => setSearchQuery('')}>
            <MaterialCommunityIcons name="close" size={20} color="#6B7280" />
          </TouchableOpacity>
        ) : null}
      </View>
      
      <View style={styles.filterRow}>
        <ScrollView 
          horizontal 
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={styles.filterContent}
        >
          <Text style={styles.filterLabel}>Status:</Text>
          {ticketStatuses.map((status) => (
            <TouchableOpacity
              key={status.key}
              style={[
                styles.filterButton,
                filterStatus === status.key && styles.activeFilterButton
              ]}
              onPress={() => setFilterStatus(status.key)}
            >
              <Text style={[
                styles.filterText,
                filterStatus === status.key && styles.activeFilterText
              ]}>
                {status.title} ({status.count})
              </Text>
            </TouchableOpacity>
          ))}
        </ScrollView>
      </View>
      
      <View style={styles.filterRow}>
        <ScrollView 
          horizontal 
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={styles.filterContent}
        >
          <Text style={styles.filterLabel}>Priority:</Text>
          {ticketPriorities.map((priority) => (
            <TouchableOpacity
              key={priority.key}
              style={[
                styles.filterButton,
                filterPriority === priority.key && styles.activeFilterButton
              ]}
              onPress={() => setFilterPriority(priority.key)}
            >
              <Text style={[
                styles.filterText,
                filterPriority === priority.key && styles.activeFilterText
              ]}>
                {priority.title}
              </Text>
            </TouchableOpacity>
          ))}
        </ScrollView>
      </View>
    </View>
  );

  const renderTicketItem = ({ item }) => (
    <TouchableOpacity 
      style={styles.ticketCard}
      onPress={() => {
        setSelectedTicket(item);
        setShowTicketModal(true);
      }}
    >
      <View style={styles.ticketHeader}>
        <View style={styles.ticketInfo}>
          <View style={styles.ticketTitleRow}>
            <Text style={styles.ticketId}>{item.id}</Text>
            <View style={[styles.priorityBadge, { backgroundColor: getPriorityColor(item.priority) }]}>
              <Text style={styles.priorityText}>{item.priority}</Text>
            </View>
          </View>
          <Text style={styles.ticketTitle}>{item.title}</Text>
          <Text style={styles.ticketCustomer}>{item.customer} • {item.contact}</Text>
        </View>
        <View style={styles.ticketStatus}>
          <View style={[styles.statusBadge, { backgroundColor: getStatusColor(item.status) }]}>
            <Text style={styles.statusText}>{item.status}</Text>
          </View>
          <MaterialCommunityIcons 
            name={getCategoryIcon(item.category)} 
            size={24} 
            color="#6B7280" 
          />
        </View>
      </View>
      
      <Text style={styles.ticketDescription} numberOfLines={2}>
        {item.description}
      </Text>
      
      <View style={styles.ticketDetails}>
        <View style={styles.detailRow}>
          <View style={styles.detailItem}>
            <MaterialCommunityIcons name="calendar" size={16} color="#6B7280" />
            <Text style={styles.detailText}>Created: {formatDate(item.createdAt)}</Text>
          </View>
          <View style={styles.detailItem}>
            <MaterialCommunityIcons name="clock" size={16} color="#6B7280" />
            <Text style={styles.detailText}>Updated: {formatDate(item.updatedAt)}</Text>
          </View>
        </View>
        <View style={styles.detailRow}>
          <View style={styles.detailItem}>
            <MaterialCommunityIcons name="account" size={16} color="#6B7280" />
            <Text style={styles.detailText}>Assigned: {item.assignedTo}</Text>
          </View>
          <View style={styles.detailItem}>
            <MaterialCommunityIcons name="calendar-clock" size={16} color="#6B7280" />
            <Text style={styles.detailText}>Due: {formatDate(item.dueDate)}</Text>
          </View>
        </View>
      </View>
      
      <View style={styles.ticketMetrics}>
        <View style={styles.metricItem}>
          <Text style={styles.metricLabel}>SLA Status:</Text>
          <View style={[styles.slaBadge, { backgroundColor: getSlaStatusColor(item.slaStatus) }]}>
            <Text style={styles.slaText}>{item.slaStatus}</Text>
          </View>
        </View>
        {item.escalationLevel > 0 && (
          <View style={styles.metricItem}>
            <MaterialCommunityIcons name="alert" size={16} color="#EF4444" />
            <Text style={styles.escalationText}>Escalated (Level {item.escalationLevel})</Text>
          </View>
        )}
      </View>
      
      {item.tags.length > 0 && (
        <View style={styles.ticketTags}>
          {item.tags.slice(0, 3).map((tag, index) => (
            <View key={index} style={styles.tag}>
              <Text style={styles.tagText}>{tag}</Text>
            </View>
          ))}
        </View>
      )}
      
      <View style={styles.ticketActions}>
        <View style={styles.actionInfo}>
          <Text style={styles.commentsCount}>
            {item.comments.length} comment{item.comments.length !== 1 ? 's' : ''}
          </Text>
          {item.attachments.length > 0 && (
            <View style={styles.attachmentInfo}>
              <MaterialCommunityIcons name="paperclip" size={16} color="#6B7280" />
              <Text style={styles.attachmentText}>{item.attachments.length}</Text>
            </View>
          )}
        </View>
        <View style={styles.quickActions}>
          <TouchableOpacity 
            style={styles.actionButton}
            onPress={() => updateTicketStatus(item.id, 'in-progress')}
          >
            <MaterialCommunityIcons name="play" size={16} color="#3B82F6" />
          </TouchableOpacity>
          <TouchableOpacity 
            style={styles.actionButton}
            onPress={() => updateTicketStatus(item.id, 'resolved')}
          >
            <MaterialCommunityIcons name="check" size={16} color="#10B981" />
          </TouchableOpacity>
        </View>
      </View>
    </TouchableOpacity>
  );

  const renderAnalytics = () => (
    <ScrollView style={styles.analyticsContainer}>
      <Text style={styles.analyticsTitle}>Support Analytics</Text>
      
      <View style={styles.analyticsGrid}>
        <View style={styles.analyticsCard}>
          <MaterialCommunityIcons name="clock" size={32} color="#3B82F6" />
          <Text style={styles.analyticsValue}>{analytics.firstResponseTime}h</Text>
          <Text style={styles.analyticsLabel}>First Response Time</Text>
        </View>
        <View style={styles.analyticsCard}>
          <MaterialCommunityIcons name="shield-check" size={32} color="#10B981" />
          <Text style={styles.analyticsValue}>{analytics.slaCompliance}%</Text>
          <Text style={styles.analyticsLabel}>SLA Compliance</Text>
        </View>
      </View>
      
      <View style={styles.analyticsDetails}>
        <View style={styles.analyticsDetailItem}>
          <Text style={styles.analyticsDetailLabel}>Escalation Rate:</Text>
          <Text style={[
            styles.analyticsDetailValue, 
            { color: analytics.escalationRate > 15 ? '#EF4444' : '#10B981' }
          ]}>
            {analytics.escalationRate}%
          </Text>
        </View>
        <View style={styles.analyticsDetailItem}>
          <Text style={styles.analyticsDetailLabel}>Top Category:</Text>
          <Text style={styles.analyticsDetailValue}>{analytics.topCategory}</Text>
        </View>
        <View style={styles.analyticsDetailItem}>
          <Text style={styles.analyticsDetailLabel}>Critical Tickets:</Text>
          <Text style={[
            styles.analyticsDetailValue, 
            { color: analytics.criticalTickets > 0 ? '#EF4444' : '#10B981' }
          ]}>
            {analytics.criticalTickets}
          </Text>
        </View>
        <View style={styles.analyticsDetailItem}>
          <Text style={styles.analyticsDetailLabel}>Overdue Tickets:</Text>
          <Text style={[
            styles.analyticsDetailValue, 
            { color: analytics.overdueTickets > 0 ? '#EF4444' : '#10B981' }
          ]}>
            {analytics.overdueTickets}
          </Text>
        </View>
      </View>
      
      <View style={styles.statusBreakdown}>
        <Text style={styles.breakdownTitle}>Ticket Status Breakdown</Text>
        {ticketStatuses.filter(s => s.key !== 'all').map((status) => (
          <View key={status.key} style={styles.breakdownItem}>
            <View style={styles.breakdownHeader}>
              <View style={styles.breakdownInfo}>
                <View style={[styles.breakdownIndicator, { backgroundColor: getStatusColor(status.key) }]} />
                <Text style={styles.breakdownName}>{status.title}</Text>
              </View>
              <Text style={styles.breakdownValue}>{status.count}</Text>
            </View>
            <View style={styles.breakdownBar}>
              <View 
                style={[
                  styles.breakdownFill, 
                  { 
                    width: `${(status.count / analytics.totalTickets) * 100}%`, 
                    backgroundColor: getStatusColor(status.key) 
                  }
                ]} 
              />
            </View>
          </View>
        ))}
      </View>
    </ScrollView>
  );

  const renderAgentItem = ({ item }) => (
    <View style={styles.agentCard}>
      <View style={styles.agentHeader}>
        <View style={styles.agentInfo}>
          <Text style={styles.agentName}>{item.name}</Text>
          <Text style={styles.agentRole}>{item.role}</Text>
        </View>
        <View style={[styles.efficiencyBadge, { backgroundColor: getEfficiencyColor(item.efficiency) }]}>
          <Text style={styles.efficiencyText}>{item.efficiency}</Text>
        </View>
      </View>
      
      <View style={styles.agentMetrics}>
        <View style={styles.agentMetricRow}>
          <View style={styles.agentMetricItem}>
            <Text style={styles.agentMetricLabel}>Assigned</Text>
            <Text style={styles.agentMetricValue}>{item.assignedTickets}</Text>
          </View>
          <View style={styles.agentMetricItem}>
            <Text style={styles.agentMetricLabel}>Resolved</Text>
            <Text style={styles.agentMetricValue}>{item.resolvedTickets}</Text>
          </View>
          <View style={styles.agentMetricItem}>
            <Text style={styles.agentMetricLabel}>Avg Resolution</Text>
            <Text style={styles.agentMetricValue}>{formatDuration(item.avgResolutionTime)}</Text>
          </View>
        </View>
        <View style={styles.agentMetricRow}>
          <View style={styles.agentMetricItem}>
            <Text style={styles.agentMetricLabel}>Satisfaction</Text>
            <Text style={[
              styles.agentMetricValue, 
              { color: getSatisfactionColor(item.customerSatisfaction) }
            ]}>
              {item.customerSatisfaction}/5
            </Text>
          </View>
          <View style={styles.agentMetricItem}>
            <Text style={styles.agentMetricLabel}>First Response</Text>
            <Text style={styles.agentMetricValue}>{item.firstResponseTime}h</Text>
          </View>
          <View style={styles.agentMetricItem}>
            <Text style={styles.agentMetricLabel}>SLA Compliance</Text>
            <Text style={[
              styles.agentMetricValue, 
              { color: item.slaCompliance >= 90 ? '#10B981' : item.slaCompliance >= 80 ? '#F59E0B' : '#EF4444' }
            ]}>
              {item.slaCompliance}%
            </Text>
          </View>
        </View>
      </View>
      
      <View style={styles.agentProgress}>
        <View style={styles.agentProgressHeader}>
          <Text style={styles.agentProgressLabel}>Performance Score</Text>
          <Text style={styles.agentProgressValue}>
            {Math.round((item.slaCompliance + (item.customerSatisfaction * 20)) / 2)}%
          </Text>
        </View>
        <View style={styles.agentProgressBar}>
          <View 
            style={[
              styles.agentProgressFill, 
              { 
                width: `${Math.round((item.slaCompliance + (item.customerSatisfaction * 20)) / 2)}%`, 
                backgroundColor: getEfficiencyColor(item.efficiency) 
              }
            ]} 
          />
        </View>
      </View>
      
      {item.escalationRate > 20 && (
        <View style={styles.escalationWarning}>
          <MaterialCommunityIcons name="alert" size={16} color="#EF4444" />
          <Text style={styles.escalationWarningText}>
            High escalation rate: {item.escalationRate}%
          </Text>
        </View>
      )}
    </View>
  );

  const getSatisfactionColor = (satisfaction) => {
    if (satisfaction >= 4.5) return '#10B981';
    if (satisfaction >= 3.5) return '#F59E0B';
    return '#EF4444';
  };

  const renderSlaTracking = () => {
    const slaTickets = tickets.filter(t => ['open', 'in-progress', 'pending'].includes(t.status));
    
    return (
      <ScrollView style={styles.slaContainer}>
        <Text style={styles.slaTitle}>SLA Tracking ({slaTickets.length} active tickets)</Text>
        
        {slaTickets.map((ticket) => {
          const timeElapsed = (new Date() - new Date(ticket.createdAt)) / (1000 * 60 * 60);
          const timeRemaining = (new Date(ticket.dueDate) - new Date()) / (1000 * 60 * 60);
          const isOverdue = timeRemaining < 0;
          
          return (
            <View key={ticket.id} style={styles.slaTicketCard}>
              <View style={styles.slaTicketHeader}>
                <View style={styles.slaTicketInfo}>
                  <Text style={styles.slaTicketId}>{ticket.id}</Text>
                  <Text style={styles.slaTicketTitle}>{ticket.title}</Text>
                  <Text style={styles.slaTicketCustomer}>{ticket.customer}</Text>
                </View>
                <View style={[styles.slaStatusBadge, { backgroundColor: getSlaStatusColor(ticket.slaStatus) }]}>
                  <Text style={styles.slaStatusText}>{ticket.slaStatus}</Text>
                </View>
              </View>
              
              <View style={styles.slaMetrics}>
                <View style={styles.slaMetricItem}>
                  <Text style={styles.slaMetricLabel}>Time Elapsed:</Text>
                  <Text style={styles.slaMetricValue}>{formatDuration(timeElapsed)}</Text>
                </View>
                <View style={styles.slaMetricItem}>
                  <Text style={styles.slaMetricLabel}>Time Remaining:</Text>
                  <Text style={[
                    styles.slaMetricValue, 
                    { color: isOverdue ? '#EF4444' : timeRemaining < 4 ? '#F59E0B' : '#10B981' }
                  ]}>
                    {isOverdue ? `Overdue by ${formatDuration(Math.abs(timeRemaining))}` : formatDuration(timeRemaining)}
                  </Text>
                </View>
              </View>
              
              <View style={styles.slaProgress}>
                <View style={styles.slaProgressBar}>
                  <View 
                    style={[
                      styles.slaProgressFill, 
                      { 
                        width: `${Math.min((timeElapsed / (timeElapsed + Math.max(timeRemaining, 0))) * 100, 100)}%`, 
                        backgroundColor: isOverdue ? '#EF4444' : timeRemaining < 4 ? '#F59E0B' : '#3B82F6'
                      }
                    ]} 
                  />
                </View>
              </View>
              
              <View style={styles.slaActions}>
                <Text style={styles.slaAssigned}>Assigned to: {ticket.assignedTo}</Text>
                <TouchableOpacity 
                  style={styles.slaActionButton}
                  onPress={() => Alert.alert('Escalate Ticket', `Escalate ${ticket.id}?`)}
                >
                  <MaterialCommunityIcons name="alert" size={16} color="#EF4444" />
                  <Text style={styles.slaActionText}>Escalate</Text>
                </TouchableOpacity>
              </View>
            </View>
          );
        })}
        
        {slaTickets.length === 0 && (
          <View style={styles.emptySla}>
            <MaterialCommunityIcons name="shield-check" size={64} color="#D1D5DB" />
            <Text style={styles.emptySlaTitle}>All SLAs Met</Text>
            <Text style={styles.emptySlaSubtitle}>No active tickets requiring SLA monitoring</Text>
          </View>
        )}
      </ScrollView>
    );
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'tickets':
        return (
          <View style={styles.ticketsContainer}>
            {renderSearchAndFilter()}
            <FlatList
              data={getFilteredTickets()}
              keyExtractor={(item) => item.id}
              renderItem={renderTicketItem}
              contentContainerStyle={styles.listContainer}
              refreshControl={
                <RefreshControl
                  refreshing={refreshing}
                  onRefresh={onRefresh}
                  colors={['#3B82F6']}
                />
              }
              showsVerticalScrollIndicator={false}
              ListEmptyComponent={() => (
                <View style={styles.emptyContainer}>
                  <MaterialCommunityIcons name="ticket-outline" size={64} color="#D1D5DB" />
                  <Text style={styles.emptyTitle}>No Tickets Found</Text>
                  <Text style={styles.emptySubtitle}>
                    <Text>{searchQuery ? 'Try adjusting your search' : 'No support tickets match the current filters'}</Text>
                  </Text>
                </View>
              )}
            />
          </View>
        );
      case 'analytics':
        return renderAnalytics();
      case 'agents':
        return (
          <FlatList
            data={agentPerformance}
            keyExtractor={(item) => item.id}
            renderItem={renderAgentItem}
            contentContainerStyle={styles.listContainer}
            showsVerticalScrollIndicator={false}
          />
        );
      case 'sla':
        return renderSlaTracking();
      default:
        return null;
    }
  };

  const renderTicketModal = () => (
    <Modal
      visible={showTicketModal}
      animationType="slide"
      presentationStyle="pageSheet"
      onRequestClose={() => setShowTicketModal(false)}
    >
      <View style={styles.modalContainer}>
        <View style={styles.modalHeader}>
          <Text style={styles.modalTitle}>
            {selectedTicket ? selectedTicket.id : 'New Ticket'}
          </Text>
          <TouchableOpacity 
            style={styles.modalCloseButton}
            onPress={() => {
              setShowTicketModal(false);
              setSelectedTicket(null);
            }}
          >
            <MaterialCommunityIcons name="close" size={24} color="#6B7280" />
          </TouchableOpacity>
        </View>
        
        <ScrollView style={styles.modalContent}>
          {selectedTicket ? (
            <View>
              <Text style={styles.modalSectionTitle}>Ticket Details</Text>
              <Text style={styles.modalText}>
                Title: {selectedTicket.title}{'\n'}
                Customer: {selectedTicket.customer}{'\n'}
                Contact: {selectedTicket.contact}{'\n'}
                Priority: {selectedTicket.priority}{'\n'}
                Status: {selectedTicket.status}{'\n'}
                Category: {selectedTicket.category}{'\n'}
                Assigned to: {selectedTicket.assignedTo}
              </Text>
              
              <Text style={styles.modalSectionTitle}>Description</Text>
              <Text style={styles.modalText}>{selectedTicket.description}</Text>
              
              <Text style={styles.modalSectionTitle}>Timeline</Text>
              <Text style={styles.modalText}>
                Created: {formatDate(selectedTicket.createdAt)}{'\n'}
                Last Updated: {formatDate(selectedTicket.updatedAt)}{'\n'}
                Due Date: {formatDate(selectedTicket.dueDate)}
                {selectedTicket.resolutionTime ? `\nResolution Time: ${formatDuration(selectedTicket.resolutionTime)}` : ''}
              </Text>
              
              <Text style={styles.modalSectionTitle}>Comments ({selectedTicket.comments.length})</Text>
              {selectedTicket.comments.map((comment) => (
                <View key={comment.id} style={styles.commentItem}>
                  <Text style={styles.commentAuthor}>
                    {comment.author} ({comment.type}) - {formatDate(comment.timestamp)}
                  </Text>
                  <Text style={styles.commentContent}>{comment.content}</Text>
                </View>
              ))}
              
              {selectedTicket.attachments.length > 0 && (
                <View>
                  <Text style={styles.modalSectionTitle}>Attachments</Text>
                  {selectedTicket.attachments.map((attachment, index) => (
                    <Text key={index} style={styles.modalText}>• {attachment}</Text>
                  ))}
                </View>
              )}
              
              <Text style={styles.modalSectionTitle}>Tags</Text>
              <Text style={styles.modalText}>
                {selectedTicket.tags.join(', ')}
              </Text>
            </View>
          ) : (
            <View>
              <Text style={styles.modalSectionTitle}>Create New Ticket</Text>
              <Text style={styles.modalText}>
                Ticket creation form would be implemented here with fields for customer, title, description, priority, category, and assignment.
              </Text>
            </View>
          )}
        </ScrollView>
      </View>
    </Modal>
  );

  if (isLoading) {
    return (
      <SafeAreaView style={styles.loadingContainer}>
        <ActivityIndicator size={36} color="#3B82F6" />
        <Text style={styles.loadingText}>Loading Support Tickets...</Text>
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle="light-content" backgroundColor="#1F2937" />
      
      {renderHeader()}
      {renderTabs()}
      {renderStats()}
      {renderContent()}
      {renderTicketModal()}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F8FAFC',
  },
  
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F8FAFC',
  },
  
  loadingText: {
    marginTop: 16,
    fontSize: 16,
    color: '#6B7280',
    fontWeight: '500',
  },
  
  // Header styles
  header: {
    paddingTop: 12,
    paddingBottom: 16,
    paddingHorizontal: 16,
  },
  
  headerContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  
  backButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  
  headerCenter: {
    flex: 1,
    alignItems: 'center',
  },
  
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#FFFFFF',
  },
  
  headerSubtitle: {
    fontSize: 14,
    color: 'rgba(255, 255, 255, 0.8)',
    marginTop: 2,
  },
  
  headerButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  
  // Tabs styles
  tabsContainer: {
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  
  tabsContent: {
    paddingHorizontal: 16,
  },
  
  tab: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    marginRight: 8,
    borderRadius: 20,
  },
  
  activeTab: {
    backgroundColor: '#EBF4FF',
  },
  
  tabText: {
    fontSize: 14,
    color: '#6B7280',
    marginLeft: 8,
    fontWeight: '500',
  },
  
  activeTabText: {
    color: '#3B82F6',
    fontWeight: '600',
  },
  
  // Stats styles
  statsContainer: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    paddingVertical: 16,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  
  statCard: {
    flex: 1,
    alignItems: 'center',
  },
  
  statValue: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1F2937',
  },
  
  statLabel: {
    fontSize: 12,
    color: '#6B7280',
    marginTop: 4,
  },
  
  // Search and filter styles
  searchContainer: {
    backgroundColor: '#FFFFFF',
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  
  searchBox: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F3F4F6',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 8,
    marginBottom: 12,
  },
  
  searchInput: {
    flex: 1,
    fontSize: 16,
    color: '#1F2937',
    marginLeft: 8,
  },
  
  filterRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },
  
  filterLabel: {
    fontSize: 12,
    color: '#6B7280',
    fontWeight: '600',
    marginRight: 8,
    minWidth: 50,
  },
  
  filterContent: {
    paddingVertical: 4,
  },
  
  filterButton: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    marginRight: 8,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  
  activeFilterButton: {
    backgroundColor: '#EBF4FF',
    borderColor: '#3B82F6',
  },
  
  filterText: {
    fontSize: 12,
    color: '#6B7280',
    fontWeight: '500',
  },
  
  activeFilterText: {
    color: '#3B82F6',
    fontWeight: '600',
  },
  
  // Tickets styles
  ticketsContainer: {
    flex: 1,
  },
  
  listContainer: {
    padding: 16,
  },
  
  ticketCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  
  ticketHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 12,
  },
  
  ticketInfo: {
    flex: 1,
  },
  
  ticketTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  
  ticketId: {
    fontSize: 14,
    fontWeight: '600',
    color: '#3B82F6',
    marginRight: 8,
  },
  
  priorityBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  
  priorityText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  
  ticketTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1F2937',
    marginBottom: 4,
  },
  
  ticketCustomer: {
    fontSize: 14,
    color: '#6B7280',
  },
  
  ticketStatus: {
    alignItems: 'flex-end',
  },
  
  statusBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    marginBottom: 8,
  },
  
  statusText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  
  ticketDescription: {
    fontSize: 14,
    color: '#374151',
    lineHeight: 20,
    marginBottom: 12,
  },
  
  ticketDetails: {
    marginBottom: 12,
  },
  
  detailRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 4,
  },
  
  detailItem: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  
  detailText: {
    fontSize: 12,
    color: '#6B7280',
    marginLeft: 4,
  },
  
  ticketMetrics: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  
  metricItem: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  
  metricLabel: {
    fontSize: 12,
    color: '#6B7280',
    marginRight: 8,
  },
  
  slaBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  
  slaText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  
  escalationText: {
    fontSize: 12,
    color: '#EF4444',
    marginLeft: 4,
    fontWeight: '500',
  },
  
  ticketTags: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 12,
  },
  
  tag: {
    backgroundColor: '#F3F4F6',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    marginRight: 8,
    marginBottom: 4,
  },
  
  tagText: {
    fontSize: 12,
    color: '#6B7280',
  },
  
  ticketActions: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: '#F3F4F6',
    paddingTop: 8,
  },
  
  actionInfo: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  
  commentsCount: {
    fontSize: 12,
    color: '#6B7280',
    marginRight: 12,
  },
  
  attachmentInfo: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  
  attachmentText: {
    fontSize: 12,
    color: '#6B7280',
    marginLeft: 4,
  },
  
  quickActions: {
    flexDirection: 'row',
  },
  
  actionButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: '#F3F4F6',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 8,
  },
  
  // Analytics styles
  analyticsContainer: {
    padding: 16,
  },
  
  analyticsTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1F2937',
    marginBottom: 16,
  },
  
  analyticsGrid: {
    flexDirection: 'row',
    marginBottom: 24,
  },
  
  analyticsCard: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: 16,
    marginRight: 8,
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  
  analyticsValue: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#1F2937',
    marginTop: 8,
  },
  
  analyticsLabel: {
    fontSize: 12,
    color: '#6B7280',
    marginTop: 4,
    textAlign: 'center',
  },
  
  analyticsDetails: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: 16,
    marginBottom: 24,
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  
  analyticsDetailItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  
  analyticsDetailLabel: {
    fontSize: 14,
    color: '#6B7280',
  },
  
  analyticsDetailValue: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1F2937',
  },
  
  statusBreakdown: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: 16,
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  
  breakdownTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1F2937',
    marginBottom: 12,
  },
  
  breakdownItem: {
    marginBottom: 12,
  },
  
  breakdownHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 4,
  },
  
  breakdownInfo: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  
  breakdownIndicator: {
    width: 12,
    height: 12,
    borderRadius: 6,
    marginRight: 8,
  },
  
  breakdownName: {
    fontSize: 14,
    color: '#374151',
    fontWeight: '500',
  },
  
  breakdownValue: {
    fontSize: 12,
    color: '#6B7280',
  },
  
  breakdownBar: {
    height: 6,
    backgroundColor: '#E5E7EB',
    borderRadius: 3,
    overflow: 'hidden',
  },
  
  breakdownFill: {
    height: '100%',
    borderRadius: 3,
  },
  
  // Agent styles
  agentCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  
  agentHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  
  agentInfo: {
    flex: 1,
  },
  
  agentName: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1F2937',
  },
  
  agentRole: {
    fontSize: 14,
    color: '#6B7280',
    marginTop: 2,
  },
  
  efficiencyBadge: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
  },
  
  efficiencyText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  
  agentMetrics: {
    marginBottom: 16,
  },
  
  agentMetricRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  
  agentMetricItem: {
    flex: 1,
    alignItems: 'center',
  },
  
  agentMetricLabel: {
    fontSize: 12,
    color: '#6B7280',
    marginBottom: 4,
    textAlign: 'center',
  },
  
  agentMetricValue: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1F2937',
    textAlign: 'center',
  },
  
  agentProgress: {
    marginBottom: 12,
  },
  
  agentProgressHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  
  agentProgressLabel: {
    fontSize: 12,
    color: '#6B7280',
  },
  
  agentProgressValue: {
    fontSize: 12,
    fontWeight: '600',
    color: '#1F2937',
  },
  
  agentProgressBar: {
    height: 6,
    backgroundColor: '#E5E7EB',
    borderRadius: 3,
    overflow: 'hidden',
  },
  
  agentProgressFill: {
    height: '100%',
    borderRadius: 3,
  },
  
  escalationWarning: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FEF2F2',
    padding: 8,
    borderRadius: 8,
    borderLeftWidth: 3,
    borderLeftColor: '#EF4444',
  },
  
  escalationWarningText: {
    fontSize: 12,
    color: '#DC2626',
    marginLeft: 8,
    fontWeight: '500',
  },
  
  // SLA styles
  slaContainer: {
    padding: 16,
  },
  
  slaTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1F2937',
    marginBottom: 16,
  },
  
  slaTicketCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  
  slaTicketHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 12,
  },
  
  slaTicketInfo: {
    flex: 1,
  },
  
  slaTicketId: {
    fontSize: 14,
    fontWeight: '600',
    color: '#3B82F6',
    marginBottom: 2,
  },
  
  slaTicketTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1F2937',
    marginBottom: 2,
  },
  
  slaTicketCustomer: {
    fontSize: 14,
    color: '#6B7280',
  },
  
  slaStatusBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  
  slaStatusText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  
  slaMetrics: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  
  slaMetricItem: {
    flex: 1,
  },
  
  slaMetricLabel: {
    fontSize: 12,
    color: '#6B7280',
    marginBottom: 4,
  },
  
  slaMetricValue: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1F2937',
  },
  
  slaProgress: {
    marginBottom: 12,
  },
  
  slaProgressBar: {
    height: 8,
    backgroundColor: '#E5E7EB',
    borderRadius: 4,
    overflow: 'hidden',
  },
  
  slaProgressFill: {
    height: '100%',
    borderRadius: 4,
  },
  
  slaActions: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  
  slaAssigned: {
    fontSize: 12,
    color: '#6B7280',
  },
  
  slaActionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
    backgroundColor: '#FEF2F2',
  },
  
  slaActionText: {
    fontSize: 12,
    color: '#DC2626',
    marginLeft: 4,
    fontWeight: '500',
  },
  
  emptySla: {
    alignItems: 'center',
    paddingVertical: 64,
  },
  
  emptySlaTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#374151',
    marginTop: 16,
  },
  
  emptySlaSubtitle: {
    fontSize: 14,
    color: '#6B7280',
    marginTop: 8,
    textAlign: 'center',
  },
  
  // Modal styles
  modalContainer: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  
  modalHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  
  modalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1F2937',
  },
  
  modalCloseButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#F3F4F6',
    justifyContent: 'center',
    alignItems: 'center',
  },
  
  modalContent: {
    flex: 1,
    padding: 16,
  },
  
  modalSectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1F2937',
    marginBottom: 8,
  },
  
  modalText: {
    fontSize: 14,
    color: '#6B7280',
    lineHeight: 20,
    marginBottom: 16,
  },
  
  commentItem: {
    backgroundColor: '#F8FAFC',
    padding: 12,
    borderRadius: 8,
    marginBottom: 8,
    borderLeftWidth: 3,
    borderLeftColor: '#3B82F6',
  },
  
  commentAuthor: {
    fontSize: 12,
    fontWeight: '600',
    color: '#374151',
    marginBottom: 4,
  },
  
  commentContent: {
    fontSize: 14,
    color: '#6B7280',
    lineHeight: 20,
  },
  
  // Empty state styles
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 64,
  },
  
  emptyTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#374151',
    marginTop: 16,
  },
  
  emptySubtitle: {
    fontSize: 14,
    color: '#6B7280',
    marginTop: 8,
    textAlign: 'center',
  },
});
